import type { MantineSize } from "@mantine/core";
import Link from "next/link";

import { Button } from "@/components/ui/elements";

import { buildGoogleMapsUrl } from "@/util/googleMapsUrl";

type Props = {
  latitude: number | null;
  longitude: number | null;
  matchingAddress: string;
  googlePlaceId: string | null;
  size?: MantineSize;
};

export function GoogleMapButton({
  latitude,
  longitude,
  matchingAddress,
  googlePlaceId,
  size = "sm",
}: Props) {
  const href = buildGoogleMapsUrl({
    latitude,
    longitude,
    matchingAddress,
    googlePlaceId,
  });
  if (!href) return null;

  return (
    <Button
      component={Link}
      href={href}
      target="_blank"
      variant="outline"
      size={size}
    >
      Google Mapsで開く
    </Button>
  );
}
